export default "__VITE_ASSET__B4Hv6V8f__"